import React, { Component } from "react";
import { FUNNEL_START } from 'utils/constants';
import projectImg from 'assets/pro_funnel/project_mick.jpg';

const NAVY  = '#1C2E3D';
const ORANGE = '#C07430';
const TEAL  = '#2D7A6A';
const GRAY  = '#5C6A78';

class ProLanding extends Component {
  constructor(props) {
    super(props);
    this.state = { sessionId: null };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "McNulty Construction";
    const params = new URLSearchParams(this.props.location ? this.props.location.search : '');
    const funnelId = params.get('funnel_id');
    const utmContent = params.get('utm_content');
    fetch(FUNNEL_START, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ funnel_id: funnelId, utm_content: utmContent }),
    })
      .then(res => res.json())
      .then(data => this.setState({ sessionId: data.session_id }))
      .catch(() => {});
  }

  render() {
    const params = new URLSearchParams(this.props.location ? this.props.location.search : '');
    if (this.state.sessionId) params.set('session_id', this.state.sessionId);
    const quizUrl = `/pro/quiz?${params.toString()}`;

    return (
      <div style={{
        minHeight: '100vh',
        background: '#E9E6E0',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '24px 16px 40px',
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
      }}>
        <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');`}</style>

        <div style={{
          background: '#fff',
          borderRadius: 16,
          boxShadow: '0 2px 24px rgba(0,0,0,0.10)',
          width: '100%',
          maxWidth: 480,
          overflow: 'hidden',
        }}>

          {/* Hero image */}
          <div style={{ position: 'relative', height: 220, overflow: 'hidden' }}>
            <img src={projectImg} alt="Recent foundation project" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }} />
            <div style={{
              position: 'absolute', bottom: 14, left: 16,
              background: 'rgba(20,35,50,0.72)',
              borderRadius: 6, padding: '6px 12px',
              color: '#fff', fontSize: 13, fontWeight: 500,
            }}>
              Recent foundation project — San Francisco
            </div>
          </div>

          {/* Content */}
          <div style={{ padding: '20px 24px 28px' }}>

            {/* Logo row */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 700, color: NAVY, letterSpacing: '-0.01em' }}>
                  McNulty Construction
                </div>
                <a href="tel:+14154202267" style={{ fontSize: 15, color: TEAL, fontWeight: 600, textDecoration: 'none' }}>
                  (415) 420-2267
                </a>
              </div>
              <div style={{ fontSize: 13, color: GRAY }}>Est. 1999</div>
            </div>

            {/* Heading */}
            <h1 style={{ fontSize: 28, fontWeight: 800, color: NAVY, lineHeight: 1.15, margin: '0 0 14px' }}>
              Get a free project review — no obligation
            </h1>

            {/* Subtitle */}
            <p style={{ fontSize: 15, color: GRAY, lineHeight: 1.6, margin: '0 0 20px' }}>
              San Francisco's foundation and structural framing specialists. Precise, code-compliant work — no surprises.
            </p>

            {/* Credential badges */}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 24 }}>
              {['License #: 771479 B, C-8', 'Fully insured', '20+ years in SF'].map(badge => (
                <span key={badge} style={{
                  border: '1px solid #D0D5DC',
                  borderRadius: 6,
                  padding: '6px 11px',
                  fontSize: 13,
                  color: NAVY,
                  fontWeight: 500,
                  background: '#fff',
                }}>
                  {badge}
                </span>
              ))}
            </div>

            {/* CTA button */}
            <button
              onClick={() => this.props.history.push(quizUrl)}
              style={{
                display: 'block', width: '100%',
                background: ORANGE, color: '#fff',
                border: 'none', borderRadius: 10,
                padding: '16px', fontSize: 17, fontWeight: 700,
                cursor: 'pointer', marginBottom: 10,
                letterSpacing: '-0.01em',
              }}
            >
              Free project review
            </button>

            {/* Reassurance */}
            <p style={{ textAlign: 'center', fontSize: 13, color: GRAY, margin: '0 0 20px' }}>
              Takes 2 minutes ·{' '}
              <span style={{ color: TEAL, fontWeight: 700 }}>We call you back within 24–48 hrs</span>
            </p>

            {/* Callout box */}
            <div style={{
              borderLeft: `3px solid ${TEAL}`,
              background: '#F0F5F3',
              borderRadius: '0 8px 8px 0',
              padding: '14px 16px',
            }}>
              <p style={{ fontSize: 14, color: GRAY, lineHeight: 1.6, margin: 0 }}>
                Not every project is a fit for us. If it isn't, we'll let you know right away — if it is, we'll call to talk next steps.
              </p>
            </div>

          </div>

          {/* Footer */}
          <div style={{ borderTop: '1px solid #ECEAE5', padding: '16px 24px', textAlign: 'center' }}>
            <a
              href="https://mcnultyconstructionsf.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: 13, color: GRAY, textDecoration: 'none' }}
            >
              mcnultyconstructionsf.com
            </a>
          </div>

        </div>
      </div>
    );
  }
}

export default ProLanding;
